import Swiper from 'swiper';
import { A11y, Pagination } from 'swiper/modules';
import 'swiper/css';

document.querySelectorAll('.large-text-testimonial .carousel').forEach((carousel) => {
	new Swiper(carousel.querySelector('.swiper'), {
		modules: [A11y, Pagination],
		a11y: {
			// Keep native <figure> semantics; Swiper defaults to role="group" on slides.
			slideRole: null,
		},
		slidesPerView: 1,
		spaceBetween: 24,
		autoHeight: true,
		watchOverflow: true,
		pagination: {
			el: carousel.querySelector('.carousel-pagination'),
			clickable: true,
		},
	});
});
